import React from 'react'

const HomeVideoSection = () => {
  return (
    <div className='flex items-center justify-center w-full bg-gradient-to-br from-blue to-[#3F86C2] h-[45vh] lg:h-[55vh] lg:mt-[400px] lg:relative my-10 rounded-3xl mx-4 lg:mx-auto lg:w-[95%]'>
      <div className="absolute inset-0 overflow-hidden rounded-3xl pointer-events-none">
        <div className="absolute -top-20 -left-20 h-72 w-72 rounded-full bg-white/10 blur-3xl"></div>
        <div className="absolute -bottom-20 -right-20 h-72 w-72 rounded-full bg-yellow/15 blur-3xl"></div>
      </div>
      <img className='lg:absolute w-[60%] lg:w-[70%] left-48 -top-64 rounded-2xl shadow-pop relative' src='/assets/images/video.png' alt='video' />
    </div>
  )
}

export default HomeVideoSection
